export default __webpack_public_path__ + "static/media/vg.21338704.svg";